export default __webpack_public_path__ + "static/media/visa-logo.892a7706.svg";